<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
	display: none;
}
</style>
<style lang="scss"></style>
<template>
	<div style="width: 100%;padding-bottom: 40px;">
		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{ $t('ziduanpeizhi') }}
			</p>
		</div>
		<div style="display: flex;width: 100%;justify-content: center;height: 320px;margin-top: 20px;">
			<el-transfer target-order="push" style="text-align: left; display: inline-block" v-model="monitorSetting.PRODUCTION_ALL_COLUMNS" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{
				noChecked: '${total}',
				hasChecked: '${checked}/${total}'
			}" @change="showColumnsChange" :data="allColumns">
				<div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
					<div>{{ $t(option.label) }}</div>
					<div>
						<!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
					</div>
				</div>

			</el-transfer>

		</div>
		<div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{ $t('yujingpeizhi') }}
			</p>
		</div>
		<div style="display: flex;align-items: center;padding-top: 14px;">
			<div style="margin-left: 12px;display: flex;flex-direction: column;">
				<label>生产达成率预警值-大于等于(%)</label>
				<label style="font-size: 12px;color: #909399;margin-top: 4px;">(生产数量/计划数量*100%)</label>
			</div>
			<el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.YUJINGPEIZHI" :precision="1" :min="0" :max="100">
			</el-input-number>
			<p style="margin-left: 12px;">%</p>
		</div>
		<div style="display: flex;align-items: center;margin-top: 12px;">
			<el-radio-group v-model="monitorSetting.YUJING_COLOR">
				<el-radio label="#F56C6C">
					<span style="display: inline-block;width: 20px;height: 20px;background: #F56C6C;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					红色
				</el-radio>
				<el-radio label="#67C23A" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #67C23A;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					绿色
				</el-radio>
				<el-radio label="#409EFF" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #409EFF;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					蓝色
				</el-radio>
				<el-radio label="#E6A23C" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #E6A23C;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					黄色
				</el-radio>
			</el-radio-group>
		</div>
		<div style="display: flex;align-items: center;margin-top: 12px;">
			<div style="margin-left: 12px;display: flex;flex-direction: column;">
				<label>生产达成率预警值-小于(%)</label>
				<label style="font-size: 12px;color: #909399;margin-top: 4px;">(生产数量/计划数量*100%)</label>
			</div>
			<el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.YUJINGPEIZHI_LESS" :precision="1" :min="0" :max="100">
			</el-input-number>
			<p style="margin-left: 12px;">%</p>
		</div>
		<div style="display: flex;align-items: center;margin-top: 12px;">
			<el-radio-group v-model="monitorSetting.YUJING_COLOR_LESS">
				<el-radio label="#F56C6C">
					<span style="display: inline-block;width: 20px;height: 20px;background: #F56C6C;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					红色
				</el-radio>
				<el-radio label="#67C23A" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #67C23A;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					绿色
				</el-radio>
				<el-radio label="#409EFF" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #409EFF;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					蓝色
				</el-radio>
				<el-radio label="#E6A23C" style="margin-left: 20px;">
					<span style="display: inline-block;width: 20px;height: 20px;background: #E6A23C;border-radius: 4px;vertical-align: middle;margin-right: 4px;"></span>
					黄色
				</el-radio>
			</el-radio-group>
		</div>
		<!-- 	<div style="display: flex;align-items: center;margin-top: 12px;">
					<div style="display: flex;flex-direction: column;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="jianyue">{{$t('jianyue')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/jianyue.jpg" />
					</div>
					<div style="display: flex;flex-direction: column;margin-left: 80px;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="tianchong">
							{{$t('tianchong')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/tianchong.jpg" />
					</div>

				</div> -->

	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_production_all_setting',
	components: {

	},

	data() {
		return {
			monitorSetting: {},
			allColumns: [{
				key: 'shebeimingcheng',
				label: this.$t('shebeimingcheng'),
				disabled: true,
			},
			{
				key: 'shengchangongdanhao',
				label: this.$t('shengchangongdanhao'),
				disabled: true,
			},
			{
				key: 'chanpinbianma',
				label: this.$t('chanpinbianma'),
				disabled: false,
			},
			{
				key: 'chanpinmingcheng',
				label: this.$t('chanpinmingcheng'),
				disabled: false,
			},
			{
				key: 'chanpinguige',
				label: this.$t('chanpinguige'),
				disabled: false,
			},
			{
				key: 'mojubianhao',
				label: this.$t('mojubianhao'),
				disabled: false,
			},
			{
				key: 'gongdanzhuangtai',
				label: this.$t('gongdanzhuangtai'),
				disabled: false,
			},
			{
				key: 'jihuashuliang',
				label: this.$t('jihuashuliang'),
				disabled: false,
			},
			{
				key: 'shengchanshuliang',
				label: this.$t('shengchanshuliang'),
				disabled: false,
			},
			{
				key: 'yibaogongliangpinshu',
				label: this.$t('yibaogongliangpinshu'),
				disabled: false,
			},
			{
				key: 'yibaogongbuliangpinshu',
				label: this.$t('yibaogongbuliangpinshu'),
				disabled: false,
			},
			{
				key: 'shengyushengchanshuliang',
				label: this.$t('shengyushengchanshuliang'),
				disabled: false,
			},
			{
				key: 'biaozhun/shishizhouqi（miao）',
				label: this.$t('biaozhun/shishizhouqi（miao）'),
				disabled: false,
			},
			{
				key: 'liangpinlv',
				label: this.$t('liangpinlv'),
				disabled: false,
			},
			{
				key: 'bulianglv',
				label: this.$t('bulianglv'),
				disabled: false,
			},
			{
				key: 'shengchanjindu',
				label: this.$t('shengchanjindu'),
				disabled: false,
			},
			{
				key: 'wangongyuceshijian',
				label: this.$t('wangongyuceshijian'),
				disabled: false,
			},
			{
				key: 'caozuoren',
				label: this.$t('caozuoren'),
				disabled: false,
			},
			{
				key: 'beizhu',
				label: this.$t('beizhu'),
				disabled: false,
			},
			]
		};
	},
	created() {
		this.resetData()
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
	},
	destroyed() { },
	methods: {
		showColumnsChange(e) {
			console.log(e)
			let index = e.indexOf('beizhu')
			if (index > 0) {
				e.splice(index, 1)
				e.push('beizhu')
			}
			//如果有备注，把备注放最后
			//保存
			//window.localStorage.setItem("column_" + this.name, JSON.stringify(this.showColumns))
		},
		resetData() {
			//可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
			let monitorSetting = localStorage.getItem("MONITOR_SETTING")
			if (!monitorSetting) {
				this.monitorSetting = {}
			} else {
				this.monitorSetting = JSON.parse(monitorSetting)
			}

			this.monitorSetting.PRODUCTION_ALL_COLUMNS = this.monitorSetting.PRODUCTION_ALL_COLUMNS !=
				null ?
				this.monitorSetting.PRODUCTION_ALL_COLUMNS : ["shebeimingcheng", "shengchangongdanhao",
					"chanpinbianma", "chanpinmingcheng", "chanpinguige", "mojubianhao", "gongdanzhuangtai", "jihuashuliang",
					"shengchanshuliang", "yibaogongliangpinshu", "yibaogongbuliangpinshu", "shengyushengchanshuliang",
					"biaozhun/shishizhouqi（miao）", "liangpinlv", "bulianglv", "shengchanjindu", "wangongyuceshijian", "caozuoren", "beizhu"
				]
			this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE = this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE !=
				null ?
				this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE : "jianyue"
			this.monitorSetting.YUJINGPEIZHI = this.monitorSetting.YUJINGPEIZHI != null ?
				this.monitorSetting.YUJINGPEIZHI : 0
			this.monitorSetting.YUJING_COLOR = this.monitorSetting.YUJING_COLOR != null ?
				this.monitorSetting.YUJING_COLOR : "#F56C6C"
			this.monitorSetting.YUJINGPEIZHI_LESS = this.monitorSetting.YUJINGPEIZHI_LESS != null ?
				this.monitorSetting.YUJINGPEIZHI_LESS : 0
			this.monitorSetting.YUJING_COLOR_LESS = this.monitorSetting.YUJING_COLOR_LESS != null ?
				this.monitorSetting.YUJING_COLOR_LESS : "#F56C6C"

			localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {

			}, 500)
		},
		save() {

			localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

			//首次进入的时候row可能还没出来，这时候emit row还没on，所以没有触发，这里加一个nextTick
			// this.$next
			this.utils.event_hub.$emit('SetProductionAll')
		}

	}
};
</script>
